import { render, staticRenderFns } from "./UserGrups.vue?vue&type=template&id=49459f8c&scoped=true&"
import script from "./UserGrups.vue?vue&type=script&lang=js&"
export * from "./UserGrups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49459f8c",
  null
  
)

export default component.exports